import styled from 'styled-components/macro'
import { layout, space } from 'styled-system'
import { ColorsMap } from '@/utils/Theme'

export const Wrapper = styled.div`
  position: relative;
  ${layout}
  ${space}
`
export const StyledSelect = styled.select`
  outline: none;
  border: none;
  width: 100%;
  height: 3rem;
  border-radius: 1.9rem;
  padding-left: 1.5rem;
  appearance: none;
  border: 1px solid ${ColorsMap.textDefault};
  color: ${ColorsMap.black};
`

export const IconWrapper = styled.div`
  position: absolute;
  bottom: 0.8rem;
  right: 1rem;
  pointer-events: none;
`
export const Label = styled.label`
  color: ${ColorsMap.textDefault};
  float: left;
  margin: 1rem 0;
`
